import { useApi } from 'hooks/useApi';
import ExtrasalesCalendarApi from 'libs/api/promo/extrasales-calendar';

export const usePromoCalendar = () => {
  const {
    loading,
    data,
  } = useApi({
    isMainPage: true,
    api: new ExtrasalesCalendarApi(),
    resourceKey: 'extrasales',
    singleResourceKey: 'extrasales',
  });
  return {
    loading,
    data,
  };
};
